import {SFC} from 'types';

import * as S from './Styles';

const Line: SFC = ({className}) => {
  return <S.Line className={className} />;
};

export default Line;
